export default "__VITE_ASSET__9ec97564__"